/**
 * @voltxampere/ui — MQ-2 gas sensor variant (Sprint 48-8)
 *
 * Sprint 48-8 — New gas sensor (LPG, propane, methane, smoke). SnO₂
 * semiconductor element heated by internal coil; resistance changes
 * with target gas concentration. Analog output 0-5 V proportional to
 * detected gas density. Optional digital output via on-module
 * comparator (threshold via potentiometer).
 *
 * Sensor activation layer drives:
 *   - VCC: 5 V (heater + sensor)
 *   - AOUT: analog 0-5 V proportional to gas density (ADC input)
 *   - DOUT: digital threshold-crossing (optional)
 *
 * Heater warm-up: 24 hours preheating recommended, 1 minute minimum.
 * Detection range 200-10000 ppm.
 *
 * Reference: Hanwei Electronics MQ-2 datasheet (rev. 2013).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`
 * (analog rail; AOUT modeled as fixed voltage in MVP).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const sensorMq2 = {
    id: "mq-2",
    nameTr: "MQ-2 (Gaz Sensörü, LPG/Propan/Metan/Duman)",
    nameEn: "MQ-2 (Gas Sensor, LPG/Propane/Methane/Smoke)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "MQ-2",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 5.0,
        heaterWarmupSec: 60, // minimum
        detectionRangePpm: { min: 200, max: 10_000 },
        targetGases: "LPG, propane, methane, smoke",
        hasDigitalOutput: true,
        digitalThresholdAdjustable: true,
        busType: "analog",
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=sensor-mq-2.js.map